import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GridSetOf1, GridSetOf2, GridSetOf3, GridSetOf4, GridSetOf5, GridSetOf6, GridSetOf7, GridSetOf8 } from "./GridSet";
import { LinkGridContainer } from "./LinkGrid.styles";
export var LinkGrid = function(param) {
    var sets = param.content.sets;
    return /*#__PURE__*/ _jsx(LinkGridContainer, {
        children: sets.map(function(set, setIndex) {
            var key = setIndex;
            switch(set.length){
                case 1:
                    return /*#__PURE__*/ _jsx(GridSetOf1, {
                        content: {
                            set: set
                        }
                    }, key);
                case 2:
                    return /*#__PURE__*/ _jsx(GridSetOf2, {
                        content: {
                            set: set
                        }
                    }, key);
                case 3:
                    return /*#__PURE__*/ _jsx(GridSetOf3, {
                        content: {
                            set: set
                        }
                    }, key);
                case 4:
                    return /*#__PURE__*/ _jsx(GridSetOf4, {
                        content: {
                            set: set
                        }
                    }, key);
                case 5:
                    return /*#__PURE__*/ _jsx(GridSetOf5, {
                        content: {
                            set: set
                        }
                    }, key);
                case 6:
                    return /*#__PURE__*/ _jsx(GridSetOf6, {
                        content: {
                            set: set
                        }
                    }, key);
                case 7:
                    return /*#__PURE__*/ _jsx(GridSetOf7, {
                        content: {
                            set: set
                        }
                    }, key);
                default:
                    return /*#__PURE__*/ _jsx(GridSetOf8, {
                        content: {
                            set: set
                        }
                    }, key);
            }
        })
    });
};
